import InvestStrategies from './InvestStrategies';

export default InvestStrategies;
